export class CustomerTenantModel {
  declare public code: string;
  declare public customerGroupFlag: boolean | null;
  declare public customerGroupName: string | null;
  declare public laboratoryName: string | null;
  declare public name: string | null;
  declare public uuid: string | null | undefined;
}
